import { useLocation, useNavigate } from "react-router";
import CTL_SVG from "./CTL_SVG";
import { useState } from "react";


export interface PropCTL_TopMenubar{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  menuList:Array<any>;
}
export default function CTL_TopMenubar( prop:PropCTL_TopMenubar ) {
  const [showSubmenu, setShowsubmenu] = useState(false);

  const navi = useNavigate();
  const location = useLocation();
  function _goNavi( url:string){
    navi( url)
    setShowsubmenu( false );
  }
  return (<>
    {showSubmenu&&<div className="
      fixed top-0 left-0 bg-black/50 
      w-screen h-screen z-20
      backdrop-blur-md
    " onClick={()=>setShowsubmenu(false)} />}
      
    <div className="
      z-20
      sticky top-0 left-0
      shadow-md shadow-black/10
      w-full text-white 
      bg-white
      flex flex-col
      rounded-b-2xl
    ">
      <div className="
        w-full 
        py-4
        px-2
        flex
      ">
        <div className="flex-1">
          <div className="cursor-pointer" onClick={() => navi("/")}>
            <img src="/logo2.svg" className="h-7" />
          </div>
        </div>
        <div className="
          cursor-pointer
        " onClick={()=>setShowsubmenu(!showSubmenu)}>
          <CTL_SVG
            className="w-8 fill-zinc-500 hover:fill-zinc-800 cursor-pointer"
            d="M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z"
          />
        </div>

      </div>
      {showSubmenu&&
      <div className="
        flex flex-col gap-1
        text-black pb-3 px-5
      ">
        <div className="border-b border-zinc-300 mb-2"></div>
        {prop.menuList.map((v,idx)=>
          <div key={idx} className={`
            text-[0.9rem] py-2 
            flex gap-1
            items-center
            px-2
            ${location.pathname==v.to&&'bg-zinc-100 rounded-lg'}
          `} 
          onClick={()=>_goNavi(v.to)}>
            <div className="h-[5px] w-[5px] bg-zinc-300" />
            <div>{v.label}</div>
          </div>
        )}
      </div>
      }
      {/* <div className="flex gap-2">
      <div className="cursor-pointer" onClick={()=>navi('/introduce')}>협회소개</div>
      <div className="cursor-pointer" onClick={()=>navi('/introduce')}>대회소개</div>
      <div className="cursor-pointer" onClick={()=>navi('/introduce')}>커뮤니티</div>
    </div> */}
    </div>
  </>);
}
